'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Decorators


// Utils

// Drop Utils


// Components


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _lodash = require('lodash');

var _ElementDropTarget = require('../element/dnd/ElementDropTarget');

var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);

var _dragAndDropUtils = require('../utils/dnd/dragAndDropUtils');

var _analytics = require('../analytics');

var _makeCanDropFn = require('../element/dnd/canDrop/makeCanDropFn');

var _makeCanDropFn2 = _interopRequireDefault(_makeCanDropFn);

var _preventDropOnSelfPredicate = require('../element/dnd/canDrop/preventDropOnSelfPredicate');

var _preventDropOnSelfPredicate2 = _interopRequireDefault(_preventDropOnSelfPredicate);

var _preventLinePredicate = require('../element/dnd/canDrop/preventLinePredicate');

var _preventLinePredicate2 = _interopRequireDefault(_preventLinePredicate);

var _preventColumnsOrLinesOnColumnsPredicate = require('../element/dnd/canDrop/preventColumnsOrLinesOnColumnsPredicate');

var _preventColumnsOrLinesOnColumnsPredicate2 = _interopRequireDefault(_preventColumnsOrLinesOnColumnsPredicate);

var _ListPresentational = require('./ListPresentational');

var _ListPresentational2 = _interopRequireDefault(_ListPresentational);

var _boardConstants = require('../../common/boards/boardConstants');

var _elementConstants = require('../../common/elements/elementConstants');

require('./ListContainer.scss');

var _elementHelper = require('../../common/elements/elementHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Handles the drop of an element onto the column.
 */
var onDrop = function onDrop(index, domNode, props, item) {
    var listId = props.listId,
        element = props.element;

    var position = { index: index };
    var draggedElements = item.draggedElements;


    var acceptedElementIds = draggedElements.filter(function (el) {
        return !(0, _elementHelper.isLine)(el) && !((0, _elementHelper.isColumn)(element) && (0, _elementHelper.isColumn)(el));
    }).map(function (el) {
        return el.get('id');
    });

    return {
        acceptedElementIds: acceptedElementIds,
        location: {
            parentId: listId,
            section: _boardConstants.BOARD_SECTIONS.INBOX,
            position: position
        },
        handledBy: domNode
    };
};

var getRangeIndex = function getRangeIndex(posY, ranges, invalidIds) {
    var currentIndex = 0;
    var currentValidIndex = 0;
    var currentRange = ranges[currentIndex];
    while (currentRange && posY > currentRange.range) {
        currentIndex++;

        if (!(0, _lodash.includes)(invalidIds, currentRange.id)) {
            currentValidIndex = currentIndex;
        }

        currentRange = ranges[currentIndex];
    }
    return currentValidIndex;
};

/* Drop Target functionality. */
var dropLocationFn = function dropLocationFn(props, monitor, component) {
    // Don't handle the drop if it's already been handled by a child.
    if ((0, _dragAndDropUtils.dropTargetAlreadyHandled)(monitor, component)) return;

    var children = props.children;

    var domNode = _reactDom2.default.findDOMNode(component);

    var item = monitor.getItem();

    // Use the item's index, or add it to the end of the list
    var dropIndex = item.index || item.index === 0 ? item.index : children.length;

    return onDrop(dropIndex, domNode, props, item);
};

var hoverFn = function hoverFn(props, monitor, component) {
    // Determine rectangle on screen

    var hoverBoundingRect = _reactDom2.default.findDOMNode(component).getBoundingClientRect();

    // Determine mouse position
    var clientOffset = monitor.getClientOffset();
    // Get pixels to the top
    var hoverClientY = clientOffset.y - hoverBoundingRect.top - component.offsetTop;

    var _monitor$getItem = monitor.getItem(),
        element = _monitor$getItem.element,
        draggedElementIds = _monitor$getItem.draggedElementIds;
    // Find the index that the hovered item is currently hovering over


    var hoveredIndex = getRangeIndex(hoverClientY, component.rangeArray, draggedElementIds);

    var showPlaceholder = true;

    if (draggedElementIds.length === 1) {
        var hoveringItemId = element.get('id');
        var hoveringItemParentId = element.getIn(['location', 'parentId']);
        var hoveringItemSection = element.get('location').get('section');

        var listId = props.listId,
            children = props.children;

        // If dragging an item from the current list, then check the index because
        // the placeholder should only be shown if its index will change.

        if (listId === hoveringItemParentId && hoveringItemSection === _boardConstants.BOARD_SECTIONS.INBOX) {
            var currentIndex = children.reduce(function (acc, child, index) {
                return hoveringItemId === child.get('id') ? index : acc;
            }, null);

            // If the index is the current position, or the next position (which would result in the same position anyway)
            // then don't show the placeholder, and just set the index to the current position so that the move event
            // won't fire.  (There's no point firing a move event when nothing changes).
            if (currentIndex === hoveredIndex || currentIndex + 1 === hoveredIndex) {
                hoveredIndex = currentIndex;
                showPlaceholder = false;
            }
        }
    }

    // Set on the item so that it can drop it at the correct index in the drop handler
    monitor.getItem().index = hoveredIndex;

    if (hoveredIndex === component.state.hoveredIndex) return;

    // If the placeholder should be shown, set the hovered index, otherwise set it to null
    component.setState({
        hoveredIndex: showPlaceholder ? hoveredIndex : null
    });
};

var dropTargetConfig = {
    drop: dropLocationFn,
    canDrop: (0, _makeCanDropFn2.default)([_preventDropOnSelfPredicate2.default, _preventLinePredicate2.default, _preventColumnsOrLinesOnColumnsPredicate2.default]),
    hover: hoverFn
};

var ListContainer = (_dec = (0, _ElementDropTarget2.default)(dropTargetConfig, _elementConstants.DROP_TARGET_TYPES.LIST), _dec(_class = function (_React$Component) {
    _inherits(ListContainer, _React$Component);

    function ListContainer(props) {
        _classCallCheck(this, ListContainer);

        var _this = _possibleConstructorReturn(this, (ListContainer.__proto__ || Object.getPrototypeOf(ListContainer)).call(this, props));

        _this.registerListElement = _this.registerListElement.bind(_this);
        _this.deregisterListElement = _this.deregisterListElement.bind(_this);
        _this.handleDoubleClick = _this.handleDoubleClick.bind(_this);
        _this.calculateListRanges = _this.calculateListRanges.bind(_this);

        _this.listElements = [];
        _this.rangeArray = [];

        _this.state = { hoveredIndex: null };
        return _this;
    }

    _createClass(ListContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // TODO This could be enhanced and made to occur when the page is idle..  I don't think there's any reason
            // why this would need to occur on component mount.  It should only be used while dragging
            // FIXME Try to use the measurements array for this instead

            // sometimes we need to add padding to the list component to make it
            // receive hover events in the correct way. (see Column.scss)
            // This messes up the offset values working out the hovered index.
            // Here, we work out how much padding is applied to the list,
            // so we can remove it from the calulated hoverY when dragging over the list
            var domNode = _reactDom2.default.findDOMNode(this);

            var paddingTop = window.getComputedStyle(domNode) && window.getComputedStyle(domNode).paddingTop;

            this.offsetTop = paddingTop ? parseInt(paddingTop, 10) : 0;

            this.calculateListRanges();
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            // Don't update when the 'canDrop' property changes because this is not used by lists
            // NOTE: Need to use should component update instead of dontUpdateForProps because this component
            //    relies on its component hierarchy for list management unfortunately.  A decorator will change this.
            return !(0, _shallowequal2.default)(this.state, nextState) || !(0, _shallowequal2.default)(this.props, nextProps, function (thisValue, nextValue, key) {
                return key === 'canDrop' ? true : undefined;
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            // If children change, calculate the space that each list element is taking up
            if (!this.props.children.equals(prevProps.children)) {
                this.calculateListRanges();
            }
        }

        /**
         * Keeps track of the list elements for this list, so their vertical ranges can be extracted on hover.
         *
         * @param listElement {ReactComponent} The ListElementContainer component for the list element.
         */

    }, {
        key: 'registerListElement',
        value: function registerListElement(listElement) {
            this.listElements.push(listElement);
        }

        /**
         * Removes an element from the array of list elements (because, for example it's been removed from the list.
         *
         * @param listElement {ReactComponent} The ListElementContainer component for the list element.
         */

    }, {
        key: 'deregisterListElement',
        value: function deregisterListElement(listElement) {
            var listElementIndex = this.listElements.indexOf(listElement);
            if (listElementIndex !== -1) {
                this.listElements.splice(listElementIndex, 1);
            }
        }
    }, {
        key: 'calculateListRanges',
        value: function calculateListRanges() {
            this.rangeArray = this.listElements.map(function (listElement) {
                return {
                    id: listElement.props.element.get('id'),
                    range: listElement.getRange()
                };
            }).sort(function (listElementA, listElementB) {
                return listElementA.range - listElementB.range;
            });
        }

        // create a new element when you double click

    }, {
        key: 'handleDoubleClick',
        value: function handleDoubleClick(event) {
            var _props = this.props,
                createShortcutCard = _props.createShortcutCard,
                listId = _props.listId,
                currentBoardId = _props.currentBoardId,
                isEditable = _props.isEditable;


            if (!isEditable || !createShortcutCard) return;

            event.preventDefault();
            event.stopPropagation();

            var clickPosY = event.clientY - _reactDom2.default.findDOMNode(this).getBoundingClientRect().top - 20;
            var index = getRangeIndex(clickPosY, this.rangeArray);

            var location = {
                parentId: listId,
                section: 'INBOX',
                position: { index: index || 0 }
            };

            createShortcutCard({ location: location, currentBoardId: listId });

            if (listId === currentBoardId) (0, _analytics.analyticsEvent)('moved-element-to-unsorted-note');
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                connectDropTarget = _props2.connectDropTarget,
                inListClass = _props2.inListClass;
            var hoveredIndex = this.state.hoveredIndex;


            return connectDropTarget(_react2.default.createElement(
                'div',
                { className: 'ListContainer',
                    onDoubleClick: this.handleDoubleClick },
                _react2.default.createElement(_ListPresentational2.default, _extends({}, this.props, {
                    inListClass: inListClass,
                    hoveredIndex: hoveredIndex,
                    registerListElement: this.registerListElement,
                    deregisterListElement: this.deregisterListElement }))
            ));
        }
    }]);

    return ListContainer;
}(_react2.default.Component)) || _class);
exports.default = ListContainer;


ListContainer.propTypes = {
    listId: _propTypes2.default.string,
    currentBoardId: _propTypes2.default.string,
    connectDropTarget: _propTypes2.default.func,
    children: _propTypes2.default.object.isRequired,
    isHovered: _propTypes2.default.bool,
    createShortcutCard: _propTypes2.default.func,
    inListClass: _propTypes2.default.string,
    isEditable: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./src/client/list/ListContainer.js
// module id = 2032
// module chunks = 0